// Dependecies
import { useState, useEffect } from 'react';
import { reject } from 'lodash';
// Store
import driverRegister from '../../store/driverRegister';
import user from '../../store/user';

function useDriverRegister(reset) {
  const [, driverActions] = driverRegister();
  const [userStore] = user();
  const [successfully, setSuccessfully] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [listDrivers, setListDrivers] = useState([]);
  const [driver, setDriver] = useState();
  const [messageErrorEmail, setMessageErrorEmail] = useState(false);
  const [messageErrorId, setMessageErrorId] = useState(false);
  const [reload, setReload] = useState(false);
  const [errorApi, setErrorApi] = useState(false);
  const [packagesCompany, SetPackagesCompany] = useState(userStore.packages);

  useEffect(() => {
    SetPackagesCompany(userStore.packages);
  }, [userStore.packages]);

  useEffect(() => {
    if (userStore.token) {
      driverActions.getDrivers(userStore.token).then(
        (res) => {
          setListDrivers(res.listDrivers);
          setSuccessfully(false);
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token, successfully]);

  const submitAdd = (data) => {
    try {
      const dat = {
        ...data,
      };
      driverActions.add(dat, userStore.token).then(
        (res) => {
          if (res.status === 200) {
            reset();
            setSuccessfully(true);
            setMessageErrorEmail(false);
            setMessageErrorId(false);
          }
          if (res.status === 400) {
            setMessageErrorEmail(true);
          }
          if (res.status === 401) {
            setMessageErrorId(true);
          }
        },
        (e) => {
          setErrorApi(e);
        }
      );
    } catch (error) {
      setErrorApi(error);
    }
  };

  const successfullyUpdate = () => {
    setSuccessfully(true);
    setOpenModal(false);
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const openModalEdit = (id) => {
    setOpenModal(false);

    driverActions.getDriverId(userStore.token, id).then(
      (res) => {
        setDriver(res.driver);
        setOpenModal(true);
      },
      (e) => {
        if (e.status === 401) {
          reject(e);
        }
      }
    );
  };

  return {
    openModalEdit,
    closeModal,
    openModal,
    listDrivers,
    driver,
    successfullyUpdate,
    submitAdd,
    messageErrorEmail,
    messageErrorId,
    reload,
    successfully,
    errorApi,
    packagesCompany,
  };
}

export default useDriverRegister;
